// import React from 'react';
// import { Card, Skeleton } from '@mui/material';
// import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';

// const formatDuration = (minutes) => {
//   if (minutes >= 60) {
//     return {
//       value: (minutes / 60).toFixed(2),
//       unit: 'hr Avg.'
//     };
//   }
//   return {
//     value: '',
//     unit: ''
//   };
// };

// const StatItem = ({ label, minutes, loading }) => {
//   const formatted = formatDuration(minutes);
//   return (
//     <div className="bg-white rounded p-3 mb-2">
//       {loading ? (
//         <>
//           <Skeleton variant="text" width="60%" height={24} />
//           <Skeleton variant="text" width="40%" height={20} />
//         </>
//       ) : (
//         <div className="flex flex-col">
//           <div className="flex items-baseline gap-1">
//             <span className="text-xl font-medium">{formatted.value}</span>
//             <span className="text-sm text-gray-500">{formatted.unit}</span>
//           </div>
//           <div className="text-sm text-gray-500">{label}</div>
//         </div>
//       )}
//     </div>
//   );
// };

// const MHEAvailabilityCard = ({ data, loading }) => {
//   const unsafeMheDate = data.date[0]?.unique_count;
//   console.log('mhe', data.date[0]?.unique_count);

//   return (
//     <div>
//       <Card
//         className="border relative border-gray-300"
//         sx={{
//           height: '276px',
//           boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
//           borderRadius: '8px'
//         }}
//       >
//         <div className="flex w-full flex-col gap-1 p-3">
//           <div className="flex items-center gap-2">
//             <PrecisionManufacturingIcon className="bg-emerald-500 text-white rounded-full p-2 text-6xl" />

//             <div style={{ width: loading ? '120px' : 'auto' }}>
//               {loading ? (
//                 <>
//                   <Skeleton variant="text" width="100%" height={40} />
//                   <Skeleton variant="text" width="80%" height={28} />
//                 </>
//               ) : (
//                 <>
//                   {/* <div className="flex items-baseline">
//                     <span className="text-3xl font-medium">{formattedAvailability.value}</span>
//                     <span className="text-sm text-gray-500 ml-1">{formattedAvailability.unit}</span>
//                   </div> */}
//                   <p className="text-lg font-semibold">Unsafe MHE</p>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
//             <div className="text-xs text-gray-500 mb-2 italic">More Statistics</div>
//             <StatItem
//               label={
//                 <>
//                   <span className="text-2xl font-semibold text-black">{unsafeMheDate ?? 0}</span>
//                   <br />
//                   <span className="text-sm text-gray-500">Unsafe MHE Movements</span>
//                 </>
//               }
//             />
//           </div>
//         </div>
//       </Card>
//     </div>
//   );
// };

// export default MHEAvailabilityCard;






import React from 'react';

const MHEAvailabilityCard = ({ data = {}, loading = false, width = '100%', height = 'auto', maxWidth = '416px', maxHeight = '287px' }) => {
  // ---- Safe data extraction ----
  const unsafeCount = Number(data?.date?.[0]?.unique_count ?? 0);

  // ---- SVGs you provided ----
  const MheHeaderSVG = ({ size = 52 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 52 52"
      fill="none"
      style={{ width: 52, height: 52, flexShrink: 0, aspectRatio: '1 / 1' }}
    >
      <path d="M8.6665 45.5C6.86095 45.5 5.32623 44.8681 4.06234 43.6042C2.79845 42.3403 2.1665 40.8056 2.1665 39C2.1665 38.0611 2.34706 37.1678 2.70817 36.3199C3.06928 35.472 3.61095 34.7404 4.33317 34.125V26C4.33317 25.3861 4.54117 24.8719 4.95717 24.4574C5.37317 24.0428 5.88739 23.8348 6.49984 23.8334H8.6665V13C8.6665 12.3861 8.8745 11.8719 9.2905 11.4574C9.7065 11.0428 10.2207 10.8348 10.8332 10.8334H23.129C23.9957 10.8334 24.7901 11.0681 25.5123 11.5375C26.2346 12.007 26.7762 12.657 27.1373 13.4875L36.1832 34.8292C36.3998 35.3348 36.5623 35.8403 36.6707 36.3459C36.779 36.8514 36.8332 37.375 36.8332 37.9167C36.8332 40.0111 36.0929 41.7986 34.6123 43.2792C33.1318 44.7598 31.3443 45.5 29.2498 45.5C27.7693 45.5 26.4057 45.1122 25.1592 44.3365C23.9126 43.5609 22.9838 42.5043 22.3728 41.1667H14.7895C14.3201 42.4667 13.5256 43.5139 12.4062 44.3084C11.2867 45.1028 10.0402 45.5 8.6665 45.5ZM47.6665 43.3334H41.1665C40.5526 43.3334 40.0384 43.1254 39.6238 42.7094C39.2093 42.2934 39.0013 41.7791 38.9998 41.1667V10.8334C38.9998 10.2195 39.2078 9.70525 39.6238 9.29069C40.0398 8.87614 40.5541 8.66814 41.1665 8.66669C41.7789 8.66525 42.2939 8.87325 42.7113 9.29069C43.1288 9.70814 43.3361 10.2224 43.3332 10.8334V39H47.6665C48.2804 39 48.7953 39.208 49.2113 39.624C49.6273 40.04 49.8346 40.5543 49.8332 41.1667C49.8317 41.7791 49.6237 42.2941 49.2092 42.7115C48.7946 43.129 48.2804 43.3363 47.6665 43.3334ZM8.6665 41.1667C9.28039 41.1667 9.79534 40.9587 10.2113 40.5427C10.6273 40.1267 10.8346 39.6125 10.8332 39C10.8317 38.3876 10.6237 37.8734 10.2092 37.4574C9.79462 37.0414 9.28039 36.8334 8.6665 36.8334C8.05262 36.8334 7.53839 37.0414 7.12384 37.4574C6.70928 37.8734 6.50128 38.3876 6.49984 39C6.49839 39.6125 6.70639 40.1274 7.12384 40.5449C7.54128 40.9623 8.0555 41.1696 8.6665 41.1667ZM29.2498 41.1667C30.1526 41.1667 30.9203 40.8511 31.553 40.2199C32.1857 39.5886 32.5013 38.8209 32.4998 37.9167C32.4984 37.0125 32.1828 36.2455 31.553 35.6157C30.9232 34.9859 30.1555 34.6696 29.2498 34.6667C28.3442 34.6638 27.5772 34.9801 26.9488 35.6157C26.3205 36.2513 26.0042 37.0183 25.9998 37.9167C25.9955 38.8151 26.3118 39.5829 26.9488 40.2199C27.5858 40.8569 28.3528 41.1725 29.2498 41.1667ZM19.3373 30.3334H29.5748L23.129 15.1667H12.9998V23.8334L19.3373 30.3334Z" fill="#ECB22E"/>
    </svg>
  );

  const MheStatSVG = ({ size = 24 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      style={{ width: 24, height: 24, flexShrink: 0, aspectRatio: '1 / 1' }}
    >
      <path d="M4 21C3.16667 21 2.45833 20.7083 1.875 20.125C1.29167 19.5417 1 18.8333 1 18C1 17.5667 1.08333 17.1543 1.25 16.763C1.41667 16.3717 1.66667 16.034 2 15.75V11H4V5H12L16.7 16.075C16.8 16.3083 16.875 16.5417 16.925 16.775C16.975 17.0083 17 17.25 17 17.5C17 18.4667 16.6583 19.2917 15.975 19.975C15.2917 20.6583 14.4667 21 13.5 21C12.8167 21 12.1873 20.821 11.612 20.463C11.0367 20.105 10.608 19.6173 10.326 19H6.826C6.60933 19.6 6.24267 20.0833 5.726 20.45C5.20933 20.8167 4.634 21 4 21ZM18 20V4H20V18H23V20H18ZM4 19C4.28333 19 4.521 18.904 4.713 18.712C4.905 18.52 5.00067 18.2827 5 18C4.99933 17.7173 4.90333 17.48 4.712 17.288C4.52067 17.096 4.28333 17 4 17C3.71667 17 3.47933 17.096 3.288 17.288C3.09667 17.48 3.00067 17.7173 3 18C2.99933 18.2827 3.09533 18.5203 3.288 18.713C3.48067 18.9057 3.718 19.0013 4 19ZM13.5 19C13.9167 19 14.271 18.8543 14.563 18.563C14.855 18.2717 15.0007 17.9173 15 17.5C14.9993 17.0827 14.8537 16.7287 14.563 16.438C14.2723 16.1473 13.918 16.0013 13.5 16C13.082 15.9987 12.728 16.1447 12.438 16.438C12.148 16.7313 12.002 17.0853 12 17.5C11.998 17.9147 12.144 18.269 12.438 18.563C12.732 18.857 13.086 19.0027 13.5 19ZM8.925 14H13.65L10.675 7H6V11L8.925 14Z" fill="#ECB22E"/>
    </svg>
  );

  // ---- Skeleton ----
  const SkeletonLoader = () => (
    <>
      <div
        style={{
          width: '100%',
          height: 110,
          borderRadius: 18,
          background: 'linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.04))',
          outline: '1px solid rgba(120,153,255,0.15)',
          marginBottom: 24
        }}
      />
      <div style={{ width: '24%', height: 26, backgroundColor: 'rgba(255,255,255,0.10)', borderRadius: 6, marginBottom: 10 }} />
      <div style={{ width: '36%', height: 22, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 6, marginBottom: 10 }} />
      <div style={{ width: '30%', height: 22, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 6 }} />
    </>
  );

  // ---- Header pill (glossy) ----
  const HeaderPill = () => (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: 'clamp(90px, 12vw, 103px)',
        borderRadius: 18,
        padding: 'clamp(12px, 3vw, 20px)',
        display: 'flex',
        alignItems: 'center',
        color: '#fff',
        overflow: 'hidden',
        background: 'linear-gradient(180deg, rgba(20,31,74,0.9) 0%, rgba(12,18,48,0.9) 100%)',
        boxShadow: 'inset 0 0 0 1px rgba(86,129,255,0.55), 0 8px 22px rgba(0,0,0,0.35)'
      }}
    >
      {/* slanted overlay like your reference */}
      <div
        style={{
          position: 'absolute',
          right: '-20%',
          top: 0,
          bottom: 0,
          width: '70%',
          transform: 'skewX(-18deg)',
          background: 'linear-gradient(180deg, rgba(7,12,32,0.65) 0%, rgba(7,12,32,0.2) 100%)',
          filter: 'blur(0.2px)'
        }}
      />

      {/* Left: Title + count */}
      <div style={{ position: 'relative', zIndex: 2, flex: 1, minWidth: 0 }}>
        <div style={{ 
          fontSize: 'clamp(14px, 2.5vw, 16px)', 
          fontWeight: 600, 
          marginBottom: 6,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>Unsafe MHE</div>

        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, minWidth: 0 }}>
          <div style={{ 
            fontSize: 'clamp(28px, 6vw, 40px)', 
            fontWeight: 300, 
            lineHeight: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>{unsafeCount}</div>
          <div style={{ 
            fontSize: 'clamp(10px, 2vw, 12px)', 
            opacity: 0.8,
            flexShrink: 0
          }}>Total Unsafe Moments</div>
        </div>
      </div>

      {/* Right: responsive icon */}
      <div
        style={{
          position: 'absolute',
          right: 'clamp(12px, 3vw, 18px)',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 3,
          flexShrink: 0
        }}
      >
        <MheHeaderSVG size={window.innerWidth < 480 ? 36 : 52} />
      </div>
    </div>
  );

  // ---- Stats Row ----
  const StatRow = ({ icon, value, label, isLast }) => (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 2vw, 12px)', marginBottom: 10 }}>
        <div
          style={{
            width: 'clamp(32px, 5vw, 36px)',
            height: 'clamp(32px, 5vw, 36px)',
            borderRadius: '50%',
            background: 'rgba(86,129,255,0.18)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outline: '1px solid rgba(86,129,255,0.35)',
            flexShrink: 0
          }}
        >
          {icon}
        </div>

        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, minWidth: 0, flex: 1 }}>
          <span style={{ 
            fontSize: 'clamp(18px, 3.5vw, 22px)', 
            fontWeight: 800,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>{value}</span>
          <span style={{ 
            fontSize: 'clamp(11px, 2vw, 13px)', 
            color: 'rgba(226,232,240,0.7)',
            flexShrink: 0
          }}>{label}</span>
        </div>
      </div>

      {!isLast && <div style={{ margin: '14px 0', height: 1, backgroundColor: 'rgba(255,255,255,0.06)' }} />}
    </div>
  );

  // ---- Main Card ----
  return (
    <div
      style={{
        position: 'relative',
        width: width,
        height: height,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        minWidth: '280px',
        borderRadius: 20,
        background: 'linear-gradient(127deg, rgba(6,11,40,0.94) 19.41%, rgba(10,14,35,0.49) 76.65%)',
        backdropFilter: 'blur(60px)',
        WebkitBackdropFilter: 'blur(60px)',
        padding: 'clamp(16px, 4vw, 24px)',
        color: '#fff',
        overflow: 'hidden',
        boxShadow: '0 12px 28px rgba(0,0,0,0.45)',
        fontFamily:
          'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"'
      }}
    >
      {loading ? (
        <SkeletonLoader />
      ) : (
        <>
          <HeaderPill />

          {/* STATISTICS */}
          <div style={{ marginTop: 'clamp(14px, 3vw, 18px)' }}>
            <div
              style={{
                fontSize: 'clamp(10px, 2vw, 12px)',
                letterSpacing: '1.4px',
                color: 'rgba(226,232,240,0.75)',
                marginBottom: 10
              }}
            >
              STATISTICS
            </div>

            <div
              style={{
                height: 'clamp(120px, 20vw, 140px)',
                overflowY: 'auto',
                paddingRight: 8,
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.3) rgba(255,255,255,0.08)'
              }}
            >
              <StatRow
                icon={<MheStatSVG />}
                value={unsafeCount}
                label="Unsafe MHE Movements"
                isLast
              />
            </div>
          </div>
        </>
      )}

      {/* soft radial glow */}
      <div
        style={{
          position: 'absolute',
          top: '-40%',
          right: '-20%',
          width: 360,
          height: 360,
          borderRadius: '50%',
          background: 'radial-gradient(closest-side, rgba(255,255,255,0.06), rgba(255,255,255,0))',
          pointerEvents: 'none',
          filter: 'blur(2px)'
        }}
      />
    </div>
  );
};

export default MHEAvailabilityCard;
